var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 125,
    viewBox: "0 0 124 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0004 112.1C89.3937 112.1 111.6 89.8933 111.6 62.5C111.6 35.1067 89.3937 12.9 62.0004 12.9C34.6071 12.9 12.4004 35.1067 12.4004 62.5C12.4004 89.8933 34.6071 112.1 62.0004 112.1ZM84.9844 54.4841C87.4057 52.0628 87.4057 48.1372 84.9844 45.716C82.5632 43.2947 78.6376 43.2947 76.2163 45.716L55.8004 66.1319L47.7844 58.116C45.3632 55.6947 41.4376 55.6947 39.0163 58.116C36.5951 60.5372 36.5951 64.4628 39.0163 66.8841L51.4163 79.2841C53.8376 81.7053 57.7632 81.7053 60.1844 79.2841L84.9844 54.4841Z",
    fill: "#00B574"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleSuccess);
export default __webpack_public_path__ + "static/media/circle-success.a853153412b9e977e3e92026cb48787e.svg";
export { ForwardRef as ReactComponent };